import { render, staticRenderFns } from "./StoreTour.vue?vue&type=template&id=932455c2&scoped=true&lang=pug"
import script from "./StoreTour.vue?vue&type=script&lang=js"
export * from "./StoreTour.vue?vue&type=script&lang=js"
import style0 from "./StoreTour.vue?vue&type=style&index=0&id=932455c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932455c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('932455c2')) {
      api.createRecord('932455c2', component.options)
    } else {
      api.reload('932455c2', component.options)
    }
    module.hot.accept("./StoreTour.vue?vue&type=template&id=932455c2&scoped=true&lang=pug", function () {
      api.rerender('932455c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/StoreTour.vue"
export default component.exports